module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-top": "100px",
      "padding-bottom": "20px"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("The author, Stanislas M. Yassukovich, was born in Paris to a Russian émigré father and a French mother. After being educated in the United States, he settled in England, pursued a career in the City of London and is regarded as one of the founders of the international capital market. He was made a Commander of the British Empire and is a Fellow of the Royal Society of Arts and a Freeman of the City of London. His previous works, "), _c('em', [_vm._v("Two Lives: A Social and Financial Memoir, Lives of the")]), _vm._v(" "), _c('em', [_vm._v("Luberon")]), _vm._v(" and "), _c('em', [_vm._v("James Grant")]), _vm._v(" were published by Austin Macauley in 2016 and 2020. He is married to the former Diana Townsend and has three children, Tatyana, Michael and Nicholas.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0